{
  "name": "@adornis/matching-week",
  "displayName": "Matching Week",
  "description": "Matching Week Platform",
  "version": "1.0.0",
  "private": true,
  "type": "module",
  "scripts": {
    "build": "adornis-cli project build --production"
  },
  "license": "ISC",
  "dependencies": {
    "@adornis/authentication": "catalog:",
    "@adornis/base": "catalog:",
    "@adornis/baseql": "catalog:",
    "@adornis/bh-debug": "workspace:^",
    "@adornis/bh-mail-editor": "workspace:^",
    "@adornis/bh-plugin-impl": "workspace:^",
    "@adornis/browser-shim": "catalog:",
    "@adornis/buchungsheld-components": "workspace:^",
    "@adornis/buchungsheld-db": "workspace:^",
    "@adornis/buchungsheld-theme": "workspace:^",
    "@adornis/chemistry": "catalog:",
    "@adornis/config": "catalog:",
    "@adornis/data-view": "catalog:",
    "@adornis/dialog": "catalog:",
    "@adornis/entity-picker": "catalog:",
    "@adornis/file-extractor": "^25.0.10",
    "@adornis/file-utils": "catalog:",
    "@adornis/filter": "catalog:",
    "@adornis/fonts": "catalog:",
    "@adornis/form-auto-filler": "^24.0.10",
    "@adornis/formfield": "catalog:",
    "@adornis/forms": "catalog:",
    "@adornis/functional-lit": "catalog:",
    "@adornis/generated-form": "catalog:",
    "@adornis/html-editor": "catalog:",
    "@adornis/internationalization": "catalog:",
    "@adornis/llm": "^45.0.10",
    "@adornis/mails": "catalog:",
    "@adornis/mongodb": "catalog:",
    "@adornis/popover": "catalog:",
    "@adornis/print": "catalog:",
    "@adornis/prometheus": "catalog:",
    "@adornis/prosemirror-editor": "catalog:",
    "@adornis/router": "catalog:",
    "@adornis/ssr": "catalog:",
    "@adornis/testing": "catalog:",
    "@adornis/translation": "catalog:",
    "@adornis/translation-core": "catalog:",
    "@adornis/user-forms": "catalog:",
    "@adornis/users": "catalog:",
    "@adornis/validation": "catalog:",
    "@adornis/versioned-entity": "^20.0.7",
    "@adornis/writer": "catalog:",
    "@date-fns/tz": "^1.5.0",
    "@lit-labs/preact-signals": "catalog:",
    "@pdf-lib/fontkit": "^1.1.1",
    "construct-style-sheets-polyfill": "catalog:",
    "cors": "catalog:",
    "daisyui": "catalog:",
    "date-fns": "catalog:",
    "express": "catalog:",
    "ics": "catalog:",
    "lit": "catalog:",
    "luxon": "catalog:",
    "pdf-lib": "catalog:",
    "rxjs": "catalog:",
    "samlify": "catalog:",
    "sanitize-html": "^2.17.7"
  },
  "devDependencies": {
    "@adornis/cli": "catalog:"
  },
  "files": [
    "dist"
  ]
}
